import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import * as moment from "moment";

@Component({
  selector: 'Openpay-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {

  public successTitle: String = "Integración exitosa"
  public successMessage: String = "Tus clientes ya pueden comenzar a pagar con Openpay."
  public successButtonCta: String = "Regresa a Tiendanube"

  public callbackUrl: any = "#"

  private code: any

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.handleQueryParams()
    this.validateTimeOfCode()
  }

  handleQueryParams(){
    this.successTitle = this.route.snapshot.queryParamMap.get("successTitle") || "Integración exitosa"
    this.successMessage = this.route.snapshot.queryParamMap.get("successMessage") || "Tus clientes ya pueden comenzar a pagar con Openpay."
    this.successButtonCta = this.route.snapshot.queryParamMap.get("successButtonCta") || "Regresa a Tiendanube"
    this.callbackUrl = this.route.snapshot.queryParamMap.get("callbackUrl") || window.location.href

    this.code = this.route.snapshot.queryParamMap.get("code")
  }

  private validateTimeOfCode = () => {

    if(!this.code){
      this.router.navigate(['not-found']).then()
      return
    }

    let codeValue = this.base64DecodeUnicode(this.code)

    let [time, place] = codeValue.split('-')

    if((moment().utc(true).valueOf() - (30 * 1000)) > +time){
      this.router.navigate(['not-found']).then()
    }

    if(place !== 'success'){
      this.router.navigate(['not-found']).then()
    }

  }

  goToCallbackUrl() {
    window.location.href = this.callbackUrl.includes("http") ? this.callbackUrl : this.base64DecodeUnicode(this.callbackUrl);
  }

  base64DecodeUnicode (str){

    let percentEncodedStr = atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('');


    return decodeURIComponent(percentEncodedStr);
  }

}
